import { FormattedMessage } from "react-intl";
import "../styles/Button.css";

interface ButtonProps {
  id?: string;
  className?: string;
  localeId: string;
  link: string;
  color: "red" | "gray";
  onClick?: () => void;
}

const Button = ({ id, localeId, link, color, className, onClick }: ButtonProps) => {
  const btnClass = color === "red" ? "tmms-btn-red" : (color === "gray" ? "tmms-btn-gray" : "");

  return ( 
    link !== "" ? (
      <a id={ id } className={`tmms-btn ${btnClass} ${className ? className : ""}`} target="_self" href={ link } onClick={ onClick }>
        <FormattedMessage id={ localeId } />
      </a>
    ) : (
      <div id={ id } className={`tmms-btn ${btnClass} ${className ? className : ""}`} onClick={ onClick }>
        <FormattedMessage id={ localeId } />
      </div>
    )
  );
};

export default Button;
